/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import StatsBar from '../../Common/StatsBar';
import { getStatsBarData, buildImgUrl } from '../../../utils/utils';
import Video from './Video';
import BgImage from './BgImage';
import HeroImage from './HeroImage';
import { isEqual, find, countBy, findIndex } from 'lodash';
import { fadeOut } from '../../../utils/animateUtils';

const Quiz = (props) => {
  const {
    t,
    data,
    itemid,
    renderQna,
    qnaItem,
    bgItem,
    heroItem,
    renderQuestionIndex,
    quizResponse,
    setQuizState,
    quizItemViewed,
    animateDom,
    trackCard,
    container,
  } = props;
  const { Title, ContentType } = data;
  let quizSelectedArr = [];

  useEffect(() => {
    renderQna('qna');
    orientaionHandle();
    return () => {
      window.removeEventListener('orientationchange', orientationChange, false);
    };
  }, []);

  const orientationChange = () => {
    const option = document.querySelector('.question__options__details');
    if (option) {
      option.scrollTop = 0;
    }
  };

  const orientaionHandle = () => {
    window.addEventListener('orientationchange', orientationChange, false);
  };

  const getBgTemplate = () => {
    let bgComponent;
    if (qnaItem && qnaItem.templateDetail_info && qnaItem.templateDetail_info.isBackgroundVideo) {
      bgComponent = (
        <Video
          data={qnaItem}
          type="bg-video"
          item={bgItem}
          renderQna={renderQna}
          key={qnaItem.itemid_s}
        ></Video>
      );
    } else if (
      qnaItem &&
      qnaItem.templateDetail_info &&
      qnaItem.templateDetail_info.isBackgroundImage
    ) {
      bgComponent = (
        <BgImage
          data={qnaItem}
          bgItem={bgItem}
          renderQna={renderQna}
          key={qnaItem.itemid_s}
        ></BgImage>
      );
    }
    return bgComponent;
  };

  const getHeroTemplate = () => {
    let heroComponent;
    if (qnaItem && qnaItem.templateDetail_info && qnaItem.templateDetail_info.isHeroVideo) {
      heroComponent = (
        <Video
          data={qnaItem}
          type="hero-video"
          item={heroItem}
          renderQna={renderQna}
          key={qnaItem.itemid_s}
        ></Video>
      );
    } else if (qnaItem && qnaItem.templateDetail_info && qnaItem.templateDetail_info.isHeroImage) {
      heroComponent = (
        <HeroImage
          data={qnaItem}
          heroItem={heroItem}
          renderQna={renderQna}
          key={qnaItem.itemid_s}
        ></HeroImage>
      );
    }
    return heroComponent;
  };

  let eventKey = '';

  const singleSelectAnswer = (questionIndex, evt) => {
    const keyCode = evt.keyCode || evt.which;
    if (evt.type === 'click' && eventKey === '') {
      radioBoxSelected(questionIndex, evt, false);
      eventKey = '';
    }
    evt.stopPropagation();
  };

  const singleSelectAnswerOnKeyDown = (questionIndex, evt) => {
    if (evt) {
      const keyCode = evt.keyCode || evt.which;
      eventKey = keyCode;
      if (eventKey && (eventKey == 13 || eventKey == 32) && evt.type === 'keydown') {
        radioBoxSelected(questionIndex, evt, false);
      }
      evt.stopPropagation();
    }
  };

  let result = {};

  const radioBoxSelected = (questionIndex, evt, bubbled = true) => {
    if (!bubbled) {
      if (
        quizResponse &&
        quizResponse[renderQuestionIndex] &&
        quizResponse[renderQuestionIndex].optionsDetail_info &&
        quizResponse[renderQuestionIndex].optionsDetail_info.correctAnswerIndex
      ) {
        const correctIndexArr =
          quizResponse[renderQuestionIndex].optionsDetail_info.correctAnswerIndex;
        if (correctIndexArr.length > 0) {
          const isCorrect = isEqual(correctIndexArr[0], questionIndex);
          if (isCorrect) {
            createData(true);
          } else {
            createData(false);
          }
          trackQna(evt);
          moveToNextQna();
        }
      }
    }
  };

  const createData = (userAnswer) => {
    const resultObj = { quizID: null, lastAttmpedQuestionIndex: 0, optionsInfo: [] };
    resultObj.quizID = itemid;
    resultObj.shareTitle = data.Title && data.Title.value;
    resultObj.lastAttmpedQuestionIndex = renderQuestionIndex + 1;
    resultObj.totalQuestion = quizResponse.length;
    if (
      typeof Storage !== undefined &&
      localStorage.getItem('userQuiz') != null &&
      localStorage.getItem('userQuiz') != 'undefined'
    ) {
      const quizStorageData = JSON.parse(localStorage.getItem('userQuiz'));
      if (quizStorageData && quizStorageData.length > 0) {
        const localQuizData = find(quizStorageData, (quiz) => quiz.quizID == itemid);
        if (localQuizData && localQuizData.optionsInfo && localQuizData.optionsInfo.length > 0) {
          resultObj.optionsInfo = [];
          localQuizData.optionsInfo.push({
            Id: quizResponse[renderQuestionIndex].rawitemid_s,
            correctAnswer: userAnswer,
          });
          resultObj.optionsInfo = localQuizData.optionsInfo;
        } else {
          resultObj.optionsInfo.push({
            Id: quizResponse[renderQuestionIndex].rawitemid_s,
            correctAnswer: userAnswer,
          });
        }
      }
    } else {
      resultObj.optionsInfo.push({
        Id: quizResponse[renderQuestionIndex].rawitemid_s,
        correctAnswer: userAnswer,
      });
    }
    /**
     * If question ended then get all details like
     * totalCorrectAnswer,totalQuestion.
     * percentage,chart details to draw chart from quizScore();
     */
    if (quizResponse.length == renderQuestionIndex + 1) {
      const count = countBy(resultObj.optionsInfo, (res) => res.correctAnswer == true);
      resultObj.totalCorrectAnswer = count.true ? count.true : 0;
      resultObj.quizRange =
        data.manutds && data.manutds.value && data.manutds.value.Range
          ? typeof data.manutds.value.Range === 'string'
            ? JSON.parse(data.manutds.value.Range)
            : data.manutds.value.Range
          : [];
      resultObj.isNumber = data.IsNumber ? data.IsNumber.value : false;
      resultObj.isQuizComplete = true;
      const resultScoreObj = quizScore(resultObj);
      if (resultObj) {
        result.quizResult = resultScoreObj;
      }
    }
    /*
     * Save Data to local storage.
     */
    storeQuizInLocalStorage(resultObj);
  };

  const quizScore = (result) => {
    /**
     * Get result with all answered question by user
     * and calculate it by percentage to draw the chart
     */
    const chartobj = {};
    try {
      if (result && result.totalQuestion) {
        let scoreMessage = '',
          percentageValue,
          outStandingScore;
        result.totalCorrectAnswer = result.totalCorrectAnswer ? result.totalCorrectAnswer : 0;
        percentageValue = (result.totalCorrectAnswer / result.totalQuestion) * 100;
        outStandingScore = result.totalCorrectAnswer + '/' + result.totalQuestion;
        chartobj.dasharray = [percentageValue, 100 - percentageValue];
        chartobj.dashoffset = 27 + (100 - percentageValue); //27 is default value
        /**
         * Calculating score message for percentage
         * or number type range from quizRange. Depends upon isNumber
         * key values from API.
         */
        if (result.quizRange && result.quizRange.length > 0) {
          let splitRange,
            scoreValue = 0;
          if (result.isNumber == true || result.isNumber == 'true' || result.isNumber == 'True') {
            scoreValue = result.totalCorrectAnswer; //For number Type range
          } else {
            scoreValue = percentageValue; //For percentage Type range
          }
          for (let i = 0; i < result.quizRange.length; i++) {
            if (result.quizRange[i].rangekey) {
              splitRange = result.quizRange[i].rangekey.split('_');
            }
            if (splitRange && splitRange.length) {
              if (scoreValue >= splitRange[0] && scoreValue <= splitRange[1]) {
                scoreMessage = result.quizRange[i].rangetext;
                break;
              }
            }
          }
        }
        chartobj.shareText = challengeFriend(outStandingScore, result.shareTitle);
        chartobj.scoreMessage = scoreMessage;
        result.chartobj = chartobj; //Append calculated result,score message and returned it.
      }
    } catch (e) {
      console.log('error in chart percentage or range!!', e);
    }
    return result;
  };

  const challengeFriend = (totalScore, title) => {
    /**
     * Set the share title dynamically with the given
     * formate it will share automaticly.
     *
     */
    const shareQuizText = t('quizShareFormatString')
      ? t('quizShareFormatString')
      : 'I just scored %1s on the Man Utd Official App quiz, %2s. Can you beat my score? Take the quiz now: %3s';
    const Obj = {
      '%1s': totalScore,
      '%2s': title,
      '%3s': '',
    };
    const shareMessage = shareQuizText.replace(/%1s|%2s|%3s/gi, (matched) => Obj[matched]);
    return shareMessage;
  };

  const storeQuizInLocalStorage = (result) => {
    if (typeof Storage !== undefined) {
      if (
        localStorage.getItem('userQuiz') === null ||
        localStorage.getItem('userQuiz') == 'undefined'
      ) {
        localStorage.setItem('userQuiz', JSON.stringify([result]));
      } else {
        const userQuizs = JSON.parse(localStorage.getItem('userQuiz'));
        if (userQuizs && userQuizs.length > 0) {
          const storedDataIndex = findIndex(userQuizs, (o) => o.quizID == result.quizID);
          if (storedDataIndex != -1) {
            userQuizs[storedDataIndex] = result;
            localStorage.setItem('userQuiz', JSON.stringify(userQuizs));
          } else {
            userQuizs.push(result);
            localStorage.setItem('userQuiz', JSON.stringify(userQuizs));
          }
        }
      }
    }
  };

  const trackQna = (el) => {
    if (el) {
      if (el.target) {
        trackCard(data, el, 'card', {
          content_type: 'question',
          card_name: Title && qnaItem && `${Title.value}: ${qnaItem.question_t}`,
          container_type: container,
        });
      }
    }
  };

  const moveToNextQna = () => {
    const buildNo = Math.floor(Math.random() * 1000);
    removeClassAnimate();
    const qnaOptions = document.querySelector('.question__options');
    if (qnaOptions && qnaOptions.style) {
      qnaOptions.style.display = 'none';
    }
    const element = document.querySelector('.fadeInFadeOutContainer');
    if (window.document.documentMode) {
      element.style.removeAttribute('filter');
    }
    fadeOut(element, {
      duration: 200,
      complete: () => {
        if (qnaOptions) {
          qnaOptions.classList.remove('animate');
        }
        setTimeout(function () {
          animateDom();
          setQuizState(result);
        }, 200);
      },
    });
    quizSelectedArr = [];
    result.selectedArr = [];
    result.renderQuestionIndex = renderQuestionIndex + 1;
    result.qnaItem = quizResponse[result.renderQuestionIndex];
    result.quizItemViewed = quizItemViewed + 1; //analytic tracking for item viewed
    const scrollWrapper = document.getElementById('query-wrapper');
    scrollWrapper.scrollTop = 0;
  };

  const removeClassAnimate = () => {
    const qnaElm = document.querySelector('.question__options__details');
    if (qnaElm) {
      const input = qnaElm.querySelectorAll('input');
      if (input && input.length > 0) {
        for (let i = 0; i < input.length; i++) input[i].checked = false;
      }
    }
  };

  const multiSelectAnswerOnKeyDown = (questionIndex, evt) => {
    if (evt) {
      evt.stopPropagation();
      const keyCode = evt.charCode ? evt.charCode : evt.which ? evt.which : evt.keyCode;
      eventKey = keyCode;
      if (eventKey === 13 || eventKey === 32) {
        checkboxselected(questionIndex, evt);
        if (eventKey === 13) {
          const checkBoxes = evt.target;
          checkBoxes.checked = !checkBoxes.checked;
        }
      }
      evt.stopPropagation();
    }
  };

  const multiSelectAnswer = (questionIndex, evt) => {
    const keyCode = evt.charCode ? evt.charCode : evt.which ? evt.which : evt.keyCode;
    if (evt.type === 'click' && eventKey === '') {
      checkboxselected(questionIndex, evt);
      if (eventKey === 13) {
        const checkBoxes = evt.target;
        checkBoxes.checked = !checkBoxes.checked;
      }
      eventKey = '';
    }
    evt.stopPropagation();
  };

  const checkboxselected = (questionIndex, evt) => {
    const index = quizSelectedArr.indexOf(questionIndex);
    if (index == -1) {
      quizSelectedArr.push(questionIndex);
    } else {
      quizSelectedArr.splice(index, 1);
    }
    quizSelectedArr.sort(function (a, b) {
      return a - b;
    });
    /*
     * 1. compare the given answer and correct answer length | then move to next question
     * 2. compare both array is equal or not to save in localstorage
     */
    if (
      quizResponse &&
      quizResponse[renderQuestionIndex] &&
      quizResponse[renderQuestionIndex].optionsDetail_info &&
      quizResponse[renderQuestionIndex].optionsDetail_info.correctAnswerIndex
    ) {
      const correctIndexArr =
        quizResponse[renderQuestionIndex].optionsDetail_info.correctAnswerIndex;
      if (correctIndexArr.length == quizSelectedArr.length) {
        const isCorrect = isEqual(correctIndexArr, quizSelectedArr);
        if (isCorrect) {
          createData(true);
        } else {
          createData(false);
        }
        trackQna(evt);
        moveToNextQna();
      }
    }
  };

  const buildImageUrl = (cropimage) => {
    try {
      if (
        cropimage &&
        cropimage.imagecropurl_s != 'undefined' &&
        cropimage.imagecropurl_s != undefined
      ) {
        if (cropimage && cropimage.imagecropurl_s && cropimage.imagecropurl_s.thumb) {
          return buildImgUrl(cropimage.imagecropurl_s.thumb);
        } else {
          return '../../../assets/images/bg/noImage.png';
        }
      }
    } catch (e) {
      console.log('image crop fail', e);
    }
  };

  return (
    <div className="quiz__wrapper">
      <div className="question fadeInFadeOutContainer">
        {/* backgroundTemplate ( Video || Image) */}
        {qnaItem && getBgTemplate()}
        <div
          className={
            qnaItem &&
            qnaItem.templateDetail_info &&
            (qnaItem.templateDetail_info.isHeroVideo || qnaItem.templateDetail_info.isHeroImage)
              ? 'question__wrapper with-hero'
              : 'question__wrapper'
          }
        >
          <div className="question__options" style={{ display: 'none' }}>
            {/* heroTemplate ( Video || Image)*/}
            {qnaItem && getHeroTemplate()}
            <div id="query-wrapper" className="question__options__details">
              {/* single choice template with and without image*/}
              {qnaItem && qnaItem.optionsDetail_info && !qnaItem.optionsDetail_info.isMultiChoice && (
                <div className="single-choice">
                  <form>
                    <fieldset
                      className={
                        qnaItem &&
                        qnaItem.optionsDetail_info &&
                        qnaItem.optionsDetail_info.isImageInOptions
                          ? 'options__wrapper img-opt'
                          : 'options__wrapper'
                      }
                    >
                      <legend>{qnaItem && qnaItem.question_t}</legend>
                      <div className="options">
                        {qnaItem &&
                          qnaItem.questionoptions_s.map((option, index) => (
                            <div key={index} className="inner-wrap">
                              <input
                                type="radio"
                                className={`input_${qnaItem.rawitemid_s + '_' + index}`}
                                id={qnaItem && qnaItem.rawitemid_s + '_' + index}
                                name={qnaItem && qnaItem.rawitemid_s}
                                onClick={(e) => {
                                  singleSelectAnswer(index, e);
                                }}
                                onKeyDown={(e) => {
                                  singleSelectAnswerOnKeyDown(index, e);
                                }}
                              />

                              <label htmlFor={qnaItem && qnaItem.rawitemid_s + '_' + index}>
                                <span
                                  aria-hidden="true"
                                  className={
                                    qnaItem &&
                                    qnaItem.optionsDetail_info &&
                                    qnaItem.optionsDetail_info.isImageInOptions
                                      ? 'imgOption'
                                      : ''
                                  }
                                ></span>
                                <i>
                                  <em>{option.optionText}</em>
                                  {qnaItem &&
                                    qnaItem.optionsDetail_info &&
                                    qnaItem.optionsDetail_info.isImageInOptions &&
                                    option &&
                                    option.imagecropurl_s && (
                                      <img
                                        aria-hidden="true"
                                        src={buildImageUrl(option)}
                                        style={{ maxHeight: '140px', maxWidth: '140px' }}
                                      />
                                    )}
                                </i>
                              </label>
                            </div>
                          ))}
                      </div>
                    </fieldset>
                  </form>
                </div>
              )}
              {/* close single choice template*/}

              {/* Multi choice template with and without image */}
              {qnaItem && qnaItem.optionsDetail_info && qnaItem.optionsDetail_info.isMultiChoice && (
                <div className="multi-choice">
                  <form>
                    <fieldset
                      className={
                        qnaItem &&
                        qnaItem.optionsDetail_info &&
                        qnaItem.optionsDetail_info.isImageInOptions
                          ? 'options__wrapper img-opt'
                          : 'options__wrapper'
                      }
                    >
                      <legend>{qnaItem.question_t}</legend>
                      <div className="options">
                        {qnaItem &&
                          qnaItem.questionoptions_s.map((option, index) => (
                            <div key={index} className="inner-wrap">
                              <input
                                type="checkbox"
                                className={`input_${qnaItem.rawitemid_s + '_' + index}`}
                                id={qnaItem && qnaItem.rawitemid_s + '_' + index}
                                name={qnaItem && qnaItem.rawitemid_s}
                                onClick={(e) => {
                                  multiSelectAnswer(index, e);
                                }}
                                onKeyDown={(e) => {
                                  multiSelectAnswerOnKeyDown(index, e);
                                }}
                              />

                              <label htmlFor={qnaItem && qnaItem.rawitemid_s + '_' + index}>
                                <span
                                  aria-hidden="true"
                                  className={
                                    qnaItem &&
                                    qnaItem.optionsDetail_info &&
                                    qnaItem.optionsDetail_info.isImageInOptions
                                      ? 'imgOption'
                                      : ''
                                  }
                                ></span>
                                <i>
                                  <em>{option.optionText}</em>
                                  {qnaItem &&
                                    qnaItem.optionsDetail_info &&
                                    qnaItem.optionsDetail_info.isImageInOptions &&
                                    option &&
                                    option.imagecropurl_s && (
                                      <img
                                        aria-hidden="true"
                                        src={buildImageUrl(option)}
                                        style={{ maxHeight: '140px', maxWidth: '140px' }}
                                      />
                                    )}
                                </i>
                              </label>
                            </div>
                          ))}
                      </div>
                    </fieldset>
                  </form>
                </div>
              )}
              {/*{{ buildImgUrl(option) }}"  */}
              {/* close Multi choice template */}
            </div>
          </div>
          <StatsBar item={getStatsBarData(data)} classes="quiz-statsbar" type="quiz"></StatsBar>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(Quiz);
